module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQHistoryTitle: 'Your Saved Color IQ Values',
        colorIQHistoryDesc: 'Your Color IQ values captured from the Shade Finder or scanned in-store.',
        latest: 'latest',
        captured: 'Captured',
        gotIt: 'Got It'
    };

    return resources[label];
};
